var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnInstallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H24.7097C32.4417 0 38.7097 6.26801 38.7097 14V26C38.7097 33.732 32.4417 40 24.7097 40H14C6.26801 40 0 33.732 0 26V14Z",
    fill: "#F0FDF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8548 11.6666H16.8548C16.3946 11.6666 16.0215 12.0397 16.0215 12.5V14.1666C16.0215 14.6269 16.3946 15 16.8548 15H21.8548C22.3151 15 22.6882 14.6269 22.6882 14.1666V12.5C22.6882 12.0397 22.3151 11.6666 21.8548 11.6666Z",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.688 13.3334H24.3547C24.7967 13.3334 25.2206 13.509 25.5332 13.8215C25.8457 14.1341 26.0213 14.558 26.0213 15V26.6667C26.0213 27.1087 25.8457 27.5327 25.5332 27.8452C25.2206 28.1578 24.7967 28.3334 24.3547 28.3334H14.3547C13.9126 28.3334 13.4887 28.1578 13.1761 27.8452C12.8636 27.5327 12.688 27.1087 12.688 26.6667V15C12.688 14.558 12.8636 14.1341 13.1761 13.8215C13.4887 13.509 13.9126 13.3334 14.3547 13.3334H16.0213",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8547 21.6667L18.5214 23.3333L21.8547 20",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9.35474 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnInstallIcon);
export default __webpack_public_path__ + "static/media/on_install_icon.02b7e8567ff5fe5aba94069121330341.svg";
export { ForwardRef as ReactComponent };